import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function SponsorsWall() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    api.get("/sponsors").then((r) => setSponsors(r.data || [])).catch(() => {});
  }, []);

  if (!sponsors.length) return null;

  return (
    <section data-testid="sponsors-wall" className="relative border-t border-white/10 bg-[#08080c] py-14">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="font-mono2 text-[10px] tracking-[0.35em] text-[#00f0ff] uppercase mb-2">Powered By</div>
        <h3 className="font-display text-3xl md:text-4xl uppercase mb-8">Our Multiverse Sponsors</h3>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {sponsors.map((s, i) => {
            const inner = (
              <img
                src={s.logo}
                alt={s.companyName}
                title={s.companyName}
                className="max-h-16 md:max-h-20 w-auto object-contain"
              />
            );
            return (
              <div
                key={i}
                data-testid={`sponsor-logo-${i}`}
                className="bg-white/95 rounded-xl px-5 py-4 grid place-items-center hover:scale-105 transition-transform"
              >
                {s.website ? (
                  <a href={s.website.startsWith("http") ? s.website : `https://${s.website}`} target="_blank" rel="noreferrer">
                    {inner}
                  </a>
                ) : inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
